import {
  CarePathDefaultTemplate,
  CarePathDefaultTemplateProps,
} from 'components/templates/carePath/landing'

export const CarePathTh = (props: CarePathDefaultTemplateProps) => {
  return <CarePathDefaultTemplate hasIntroCarepathModal {...props} />
}
